export function resolveOrderDetailValue<T>(
  preferredValue: T | null | undefined,
  fallbackValue: T
): T {
  if (preferredValue === null || preferredValue === undefined) {
    return fallbackValue;
  }

  return preferredValue;
}
